import React from 'react';

function BenefitItem({
  title, url, image,
}) {
  return (
    <div className="flex flex-col gap-[30px]">
      <a href={url}>
        <img className="rounded-xl w-full aspect-square object-cover" width="full" height="auto" src={image} alt="benefit" />
      </a>
      <a href={url}>
        <h4 className="text-lg m-0 text-gr-gray font-big">
          {title}
        </h4>
      </a>
    </div>
  );
}

export default BenefitItem;
